const rankingItems = [
  { rank: 1, title: '某顶流艺人深夜发文引爆全网', hot: '🔥 128万', tag: '吃瓜', trend: 'up' },
  { rank: 2, title: '2026上半年手机销量排行榜', hot: '🔥 96万', tag: '科技', trend: 'up' },
  { rank: 3, title: '618电商大促省钱攻略导航', hot: '🔥 85万', tag: '购物', trend: 'up' },
  { rank: 4, title: '多地高温红色预警防暑指南', hot: '📈 73万', tag: '民生', trend: 'up' },
  { rank: 5, title: '热门综艺录制现场突发状况', hot: '📈 68万', tag: '吃瓜', trend: 'new' },
  { rank: 6, title: '国际金价波动投资建议汇总', hot: '📊 52万', tag: '财经', trend: 'up' },
  { rank: 7, title: '暑期旅游热门目的地比价导航', hot: '📊 47万', tag: '出行', trend: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">热门排行</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            全网热度最高的内容排行，实时追踪网民关注焦点
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 py-3.5 px-4 rounded-xl cursor-pointer transition-colors duration-200 hover:bg-background-100 ${
                i < rankingItems.length - 1 ? 'mb-1' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-500 text-background-50' :
                item.rank === 3 ? 'bg-primary-400 text-background-50' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${
                    item.tag === '吃瓜' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '科技' || item.tag === '购物' ? 'bg-primary-100 text-primary-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                  {item.trend === 'new' && (
                    <span className="text-[10px] font-semibold text-accent-500">NEW</span>
                  )}
                </div>
                <h3 className="font-medium text-sm md:text-base text-foreground-900 truncate">{item.title}</h3>
              </div>
              <div className="whitespace-nowrap text-xs text-foreground-500 flex-shrink-0">{item.hot}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}